<template>
  <div class="project-mutate-residentials">
    <UpsellBanner
      v-if="project.id && !addons.includes('project:presentation')"
      :title="$t('ctaResidentialSaleUpgradeTitle')"
      :description="$t('ctaResidentialSaleUpgradeDescription')"
      :action="$t('getStarted')"
      @action="
        $bus.emit('pricing:show', {
          addon: 'project:presentation',
          options: { units },
          action: () => addon('project:presentation'),
        })
      "
      class="mb-2"
    />
    <Residentials v-if="isActive" :show-settings="true" />
    <CustomFields
      v-model="value.customFields"
      :schema="customFieldSchemas"
      :data="data"
      :placement="['residentials', 'project:residentials']"
      :validator="validator"
      validator-prefix="customFields"
      :disabledFields="$path('metadata.disabledFields.project', project)"
    />
  </div>
</template>

<script>
import { i18n } from '@/i18n'
import { mapState } from 'vuex'

import Residentials from '@/components/Project/Residentials'
import CustomFields from '@kvass/custom-fields'
import UpsellBanner from '@/components/Upsell/Banner'

const meta = {
  order: 1002,
  id: 'residentials',
  label: i18n.tc('unit', 2),
  icon: ['fal', 'home'],
}

export { meta }
export default {
  props: {
    data: Object,
    value: Object,
    isActive: Boolean,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
  },
  computed: {
    ...mapState('Project', {
      project: state => state.item,
      addons(state) {
        return this.$path('metadata.addons', state.item) || []
      },
      units(state) {
        return this.$path('metadata.limits.units', state.item)
      },
    }),
  },
  methods: {
    addon(addon) {
      return this.$store
        .dispatch('Project/addon', {
          addon,
          state: true,
          project: this.project.id,
        })
        .then(() => this.addons.push(addon))
    },
  },
  components: {
    CustomFields,
    Residentials,
    UpsellBanner,
  },
}
</script>

<style lang="scss">
.project-mutate-residentials {
  max-width: 1200px;
}
</style>
